// Copyright (c) 2023, Alix Mougenot (Au pied des Arbres), alix.mougenot@gmail.com
// See license file.
import { createApp, h } from "vue";
import { createPinia } from "pinia";
import * as Sentry from "@sentry/vue";
import {CkeditorPlugin } from "@ckeditor/ckeditor5-vue";

import App from "./App.vue";
import router from "./router";

import "./assets/mdb.min.css";
import "./assets/main.scss";

const sentry_dsn = import.meta.env.VITE_SENTRY_DSN;

const app = createApp({
  setup() {},
  render: () => h(App),
});

if (sentry_dsn) {
  Sentry.init({
    app,
    dsn: sentry_dsn,
    environment: import.meta.env.PROD ? "production" : "dev",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 0.1, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [],
    // Session Replay
    replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

app.use(createPinia());
app.use(router);
app.use(CkeditorPlugin);

app.mount("#app");
